import { SignalIcon } from "@heroicons/react/24/solid";
import { motion } from "framer-motion";

export default function LoadingAnimation() {
    return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <motion.div animate={{ rotate: 360 }} transition={{ duration: 2, repeat: Infinity, ease: "linear" }} className="w-16 h-16 mx-auto mb-6">
          <SignalIcon className="w-full h-full text-blue-600" />
        </motion.div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Loading...</h1>
        <div className="h-1 bg-gradient-to-r from-indigo-500 to-blue-500 rounded-full max-w-md mx-auto" />
      </div>
    </div>
  )};